import { FormControl, Stack, TextField, Autocomplete, MenuItem, InputLabel, Select, Typography, Alert, Snackbar } from '@mui/material'
import React, { useState, useContext, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import { useSelector, useDispatch } from 'react-redux';
import ItemPropertiesDelimiterInput from '../ItemPropertiesDelimiterInput';
import { api, useGetDatatypePropertiesQuery } from '../../../redux/api';
import TPCheckbox from '../../TemplateProperties/TPCheckbox'
import { LOOP_RECORD } from '../../../constants/loopRecordOptions';
import VariableCollection from '../OutboundRecordProperties/VariableCollection';
import CustomDBField from '../OutboundRecordProperties/CustomDBField';
import SourceType from '../../TemplateProperties/SourceType';
import SourceTypeInboundDataRenderer from '../../TemplateProperties/SourceTypeComponents/SourceTypeInboundDataRenderer';
import { RecordPropertiesCheckBox, filterNodes } from '../OutboundRecordProperties/OutboundRecordProperties';
import { cloneDeep, debounce, isEqual } from 'lodash';
import { eachDeep } from 'deepdash-es/standalone';
import { treeActions } from '../../../redux/slices/treeSlice';
import { filterOutNodeTypes } from '../../../utils/utilFunctions';
import { inboundTemplateToRcTree } from '../../../utils/rctreeDataConversion';
import { FieldPropHL7Datatype } from './FieldPropHL7Datatype';
// import { Snackbar } from '@mui/material/node_modules/@mui/base'; 

function OutboundFieldGroupProperties() {
  const { t } = useTranslation();
  
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const { account } = useSelector((state) => state.queryParams);
  const { FILETYPE, FILETYPE_VERSION } = rightTree.tree.templateHeader;
  const DEPENDENCIES = useSelector(state => state.treeData.outbound.rightTree.tree.templateHeader?.DEPENDENCIES || '');
  const dispatch = useDispatch()
  
  const [fieldGroupName, setFieldGroupName] = useState('') 
  const [hl7Datatype, setHl7Datatype] = useState('')
  const [hl7DatatypeDropdownItems, setHl7DatatypeDropdownItems] = useState([]);
  const [repeatableFldGrp, setRepeatableFldGrp] = useState(false);
  const [loopRecordValue, setLoopRecordValue] = useState('')
  const [elementId, setElementId] = useState('')
  const [repeatableElementGroup, setRepeatableElementGroup] = useState(false)
  const [showCheckbox,setShowCheckbox] = useState(true);
  const [showCheckboxBefore, setShowCheckboxBefore] = useState(false);
  const [treeData,setTreeData] = useState({header:[],body:[],trailer:[]});
  const [expandActions,setExpandActions] = useState({tab:'',keys:[]});
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState('')
  const [error, setError] = useState(false);
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });

  const { data: hl7DatatypeOptions } = useGetDatatypePropertiesQuery({
    account,
    report_type: 'hl7',
    version: FILETYPE_VERSION
  });

  const handleSourceNameSelect = (mapname) => {
  }
  const valuesHandler = (values) => {
    const { PARENT, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, SOURCE_REPEATING_FIELD } = values;
    let newSelectedNode = cloneDeep(selectedNode);
    const updatedTranslatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if ( obj && obj.key === selectedNode.key) {
        // Update properties based on values
        obj.LOOP_SOURCE_NAME = RECORD_TYPE;
        obj.PARENT = PARENT;
        obj.TYPE = RECORD_TYPE;
        obj.ACTION= ACTION;
        obj.INDEX= INDEX;
        obj.MAP_REPETITION_INDEX = MAP_REPETITION_INDEX;
        obj.SOURCE_REPEATING_FIELD = SOURCE_REPEATING_FIELD || undefined;
         
        
      }
      newSelectedNode = obj;
      return obj;
    });

    //prevent unnecessary dispatch
    if (isEqual(translatedData, updatedTranslatedData)) return;

    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: newSelectedNode,
      })
    );
  
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedTranslatedData,
      })
    );
  };
  
  const recordLoopControlValuesHandler = (values) => {
     const {PARENT,MAPNAME,RECORD_TYPE,ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD } = values
     const updatedTranslatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if ( obj && obj.key === selectedNode.key) {
        // Update properties based on values
        obj.LOOP_SOURCE_NAME = MAPNAME;
        obj.SOURCE_PARENT = PARENT;
        obj.SOURCE_TYPE = RECORD_TYPE;
        obj.ACTION= ACTION;
        obj.INDEX= INDEX;
        obj.MAP_REPETITION_INDEX = MAP_REPETITION_INDEX;
        obj.SOURCE_REPEATING_FIELD = SOURCE_REPEATING_FIELD || undefined;
        obj.CUSTOM_DB_FIELD = CUSTOM_DB_FIELD;
        obj.PLUGIN_NAME = PLUGIN_NAME;
        obj.WF_ITEM_ID = WF_ITEM_ID;
        obj.WF_ITEM_LOCATION = WF_ITEM_LOCATION;
         
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: obj,
          })
        );
      }
  
      return obj;
    });

    //prevent unnecessary dispatch
    if (isEqual(translatedData, updatedTranslatedData)) return;
  
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedTranslatedData,
      })
    );

  }
  const COMPONENT_MAPPING_OBJ = {
    VARIABLE_COLLECTION: <VariableCollection />,
    CUSTOM_DB_FIELD: <CustomDBField />,
    RECORD_LOOP_CONTROL: (
      <SourceType
        node={{
          PARENT: selectedNode.SOURCE_PARENT,
          MAPNAME: selectedNode.LOOP_SOURCE_NAME,
          RECORD_TYPE: selectedNode.SOURCE_TYPE,
          key: selectedNode.key,
          ACTION: selectedNode?.ACTION,
					INDEX: selectedNode?.INDEX,
          MAP_REPETITION_INDEX: selectedNode?.MAP_REPETITION_INDEX,
          CUSTOM_DB_FIELD: selectedNode?.CUSTOM_DB_FIELD,
          PLUGIN_NAME: selectedNode?.PLUGIN_NAME,
        }}
        valuesHandler={recordLoopControlValuesHandler}
        callerComponent='recordProperties'
      />
    ),
    INBOUND_DATA: (
      <SourceTypeInboundDataRenderer
        allowAllTreeSelection={true}
        treeData={treeData}
        expandActions={expandActions}
        setTab={setTab}
        handleSourceNameSelect={handleSourceNameSelect}
        valuesHandler={valuesHandler}
        src="INBOUND_DATA"
        node={{
          PARENT: selectedNode.PARENT,
          MAPNAME: selectedNode.LOOP_SOURCE_NAME,
          RECORD_TYPE: selectedNode.TYPE,
          key: selectedNode.key
        }}
        onlyRecord={true}
        isLoading={isLoading}
		    showInboundTree={true}
      />
    ),
  };

  const submitChange = (key, value, callback) => {
    let newSelectedNode = cloneDeep(selectedNode);
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key === selectedNode.key) {
        switch (key) {
          case 'TYPE':
            if (value === "INBOUND_DATA") {
              obj.SOURCE_TYPE = value;
              delete obj.TYPE;
            } else {
              delete obj.SOURCE_TYPE;
              obj.TYPE = value;
              obj.LOOP_SOURCE_NAME = value;
            }
            break;
          case 'DESCRIPTION':
            obj[key] = value;
            obj.title = `${t("FIELD_GROUP")}: ${value}`;
            break;
          case 'REPEATING':
            obj[key] = value;
            obj.ICON_DISPLAY = value === 'TRUE' ? 'REPEATING_FIELD_GROUP' : 'FIELD_GROUP';
            if (value === 'FALSE') {
              delete obj.TYPE;
              delete obj.LOOP_SOURCE_NAME;
              obj.LOOP = 'SINGLE';
            }
            break;
          default:
            obj[key] = value;
            break;
        }

        newSelectedNode = obj
      }
      // Continue traversal if the current object has children
      if (Array.isArray(obj?.children)) {
        return obj.children;
      }
    });

    //prevent unnecessary dispatch
    if (isEqual(translatedData, updatedData)) return;

    // Update the selected node in the right tree
    dispatch(
      treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: newSelectedNode,
      })
    );
  
    // Update the translated data in the right tree
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  
    // Execute callback if provided
    if (callback && typeof callback === "function") {
      callback();
    }
  };
  

  const handleFieldGroupChange = (e) => {
    const { value } = e.target
    setFieldGroupName(value);
    if (value.includes('/')) {
      setError(true);
    } else {
      setError(false);
      debounceChangeHandler('DESCRIPTION',value)
    }
  }

  const handleRepeatableFieldGroup = (value) => {
    setRepeatableFldGrp(value)
    debounceChangeHandler('REPEATING',value.toString().toUpperCase())
  }

  const handleElementIdChange = (e) =>{
    const { value } = e.target
    setElementId(value)
    debounceChangeHandler("ELEMENT_ID",value)
  }

  const handleRepeatableElementGroup = (value) => {
    setRepeatableElementGroup(value)
    debounceChangeHandler('REPEATING',value.toString().toUpperCase())
  }

  const handleLoopRecordChange = (e) => {
    const value = e.target.value;
    setLoopRecordValue(value);
    setShowCheckboxBefore(value === "INBOUND_DATA");
  };

  useEffect(() => {
    if (hl7DatatypeOptions?.data) {
      setHl7DatatypeDropdownItems([t('SELECT'), ...hl7DatatypeOptions.data]);
    }
  }, [hl7DatatypeOptions]);

  const debounceChangeHandler = useCallback(debounce(submitChange,400),[
    rightTree.currentTab,
    rightTree.tree
  ])
  const loopRecordVal = (node) => {
    if (LOOP_RECORD.some(option => option.value === node.TYPE)) {
      setLoopRecordValue(node.TYPE);
    } else {
      setLoopRecordValue(node?.SOURCE_TYPE || t('SELECT'));
    }
  }

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  }

  useEffect(() => {
    if (selectedNode && LOOP_RECORD.length > 0) {
        setFieldGroupName(selectedNode?.DESCRIPTION || "");
        setHl7Datatype(selectedNode?.HL7_DATA_TYPE || t('SELECT'))
        setRepeatableFldGrp(selectedNode?.REPEATING === 'TRUE' || false);
        setElementId(selectedNode?.ELEMENT_ID || "");
        setRepeatableElementGroup(selectedNode?.REPEATING === 'TRUE' || false)
        loopRecordVal(selectedNode)
    }
  }, [selectedNode?.key,selectedNode,LOOP_RECORD]);

  useEffect(()=>{
    if(loopRecordValue === 'INBOUND_DATA'){
    const dependency = DEPENDENCIES?.split('/') || [];
    const workflow = dependency[0] || '';
    const template = dependency[2] || '';
    if(workflow && template){
        setIsLoading(true);
        dispatch(api.endpoints.getInboundTemplateData.initiate({
            workflowGroupName:workflow,
            templateName:template,
            account:account
        },{forceRefetch:true}))
        .then(res=>{
          if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res.data.message, isOpen: true, type: 'error' });
          else {
            const headerData = filterOutNodeTypes(filterNodes(inboundTemplateToRcTree(res.data,'HEADER'),'header'),[])
            const bodyData = filterOutNodeTypes(filterNodes(inboundTemplateToRcTree(res.data,'BODY'),'body'),[])
            const trailerData = filterOutNodeTypes(filterNodes(inboundTemplateToRcTree(res.data,'TRAILER'),'trailer'),[])
            setTreeData(prev=>{return {header:headerData,body:bodyData,trailer:trailerData}});
            setIsLoading(false);
          }
        })
    }
     else setIsLoading(false)
  }
  setShowCheckbox(loopRecordValue !== 'RECORD_LOOP_CONTROL')

  },[DEPENDENCIES,loopRecordValue])
  
  return (
    <>
      <Stack spacing={"15px"} className="tp-segment">
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            autoCapitalize="off"
            type="text"
            className="width-100"
            name="fieldGroupName"
            label={t("LBL_FLD_GRP_NAME")}
            value={fieldGroupName}
            onChange={handleFieldGroupChange}
            error={error}
            helperText={error ? t('BOX_FLD_GRP_NAME_INVALID') : ""}
          />
        </FormControl>
        {["MULIT_DELIMITED", "DELIM_FLD_ID"].includes(FILETYPE) && (
          <>
            <FormControl className="width-100" size="small">
              <ItemPropertiesDelimiterInput
                default
                label={t("LBL_FLD_DELIM_OVERRIDE_OPTIONAL")}
                name={"DELIMITER"}
              />
            </FormControl>
          </>
        )}
        {FILETYPE === "HL7" && (
          <>
            <FieldPropHL7Datatype />
            <FormControl>
              <TPCheckbox
                label={t("BTN_FLD_GRP_REPEATABLE")}
                checked={repeatableFldGrp}
                handleCheck={(checked) => {
                  handleRepeatableFieldGroup(checked);
                }}
              />
            </FormControl>
            {showCheckbox && showCheckboxBefore && <RecordPropertiesCheckBox />}
            {repeatableFldGrp && (
              <>
                <FormControl
                  variant="outlined"
                  className="width-100"
                  size="small">
                  <InputLabel id="loopRecordDropdownLabel">
                    {t("LBL_LOOP_OVER_OPTIONAL")}
                  </InputLabel>
                  <Select
                    className="width-100"
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    name="loopRecord"
                    value={loopRecordValue}
                    label={t("LBL_LOOP_OVER_OPTIONAL")}
                    onChange={(e) => {
                      debounceChangeHandler("TYPE", e.target.value, () => {
                        handleLoopRecordChange(e);
                      });
                    }}>
                    {LOOP_RECORD.map((obj, key) => (
                      <MenuItem key={key} value={obj.value}>
                        {obj.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {loopRecordValue &&
                  !["INBOUND_DATA", "RECORD_LOOP_CONTROL"].includes(
                    loopRecordValue
                  ) &&
                  COMPONENT_MAPPING_OBJ[loopRecordValue]}

                {loopRecordValue === "RECORD_LOOP_CONTROL" && (
                  <Typography
                    sx={{ borderBottom: "solid 1px rgba(0,0,0,0.12)" }}>
                    {t("LBL_DATA_SOURCE")}
                  </Typography>
                )}

                {loopRecordValue === "INBOUND_DATA" && (
                  <div
                    className="flex"
                    style={{ justifyContent: "space-between" }}>
                    <Typography style={{ fontWeight: "bold" }}>
                      {t("LBL_SHOWING_LOOPS_ONLY")}
                    </Typography>
                  </div>
                )}

                {loopRecordValue &&
                  ["INBOUND_DATA", "RECORD_LOOP_CONTROL"].includes(
                    loopRecordValue
                  ) &&
                  COMPONENT_MAPPING_OBJ[loopRecordValue]}
              </>
            )}
            {showCheckbox && !showCheckboxBefore && (
              <RecordPropertiesCheckBox />
            )}
          </>
        )}
        {FILETYPE === "EDI" && (
          <>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                autoComplete="off"
                className="width-100"
                label={t("MAP_ELEMENT_ID")}
                value={elementId}
                onChange={handleElementIdChange}
              />
            </FormControl>
            {["5010", "5010H2"].includes(FILETYPE_VERSION) && (
              <FormControl>
                <TPCheckbox
                  label={t("BTN_ELE_GRP_REPEATABLE")}
                  checked={repeatableElementGroup}
                  handleCheck={handleRepeatableElementGroup}
                />
              </FormControl>
            )}
          </>
        )}
      </Stack>
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default OutboundFieldGroupProperties